import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "inline-flex shadow-sm rounded-md divide-x divide-indigo-600" }
const _hoisted_3 = { class: "relative z-0 inline-flex shadow-sm rounded-md divide-x divide-indigo-600" }
const _hoisted_4 = { class: "relative inline-flex items-center" }
const _hoisted_5 = { class: "ml-2.5 text-sm font-medium" }
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "mt-2 text-faded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListboxLabel = _resolveComponent("ListboxLabel")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!

  return (_openBlock(), _createBlock(_component_Listbox, { as: "div" }, {
    default: _withCtx(() => [
      _createVNode(_component_ListboxLabel, { class: "sr-only" }, {
        default: _withCtx(() => [
          _createTextVNode(" Change attribute class ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ListboxButton, { class: "relative inline-flex items-center bg-black px-2 py-1 rounded-md text-sm font-medium" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.displayedLabel), 1 /* TEXT */)
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.displayedLabel), 1 /* TEXT */),
                _createVNode(_component_ChevronDownIcon, {
                  class: "h-5 w-5 ml-2",
                  "aria-hidden": "true"
                })
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _createVNode(_Transition, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ListboxOptions, { class: "origin-top-left absolute z-10 left-0 mt-2 w-72 rounded-md shadow shadow-gray-900 overflow-hidden bg-black divide-y divide-gray-200 ring-1 ring-black ring-opacity-5 focus:outline-none border border-gray-400" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, i) => {
                  return (_openBlock(), _createBlock(_component_ListboxOption, {
                    as: "template",
                    key: i,
                    value: entry.value
                  }, {
                    default: _withCtx(({active, selected}) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
								active ? 'text-white bg-bg-light' : 'text-faded',
								'cursor-pointer select-none relative p-4 text-sm',
							]),
                        onClick: ($event: any) => (_ctx.selectEntry($event, entry))
                      }, [
                        _createCommentVNode(" <span>{{ active }}-{{ selected }}</span> "),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(entry.name), 1 /* TEXT */),
                            selected
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(active ? 'text-white' : 'text-faded')
                                }, [
                                  _createVNode(_component_CheckIcon, {
                                    class: "h-5 w-5",
                                    "aria-hidden": "true"
                                  })
                                ], 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(entry.subtitles), 1 /* TEXT */)
                        ])
                      ], 10 /* CLASS, PROPS */, _hoisted_7)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}